/*
 * planyo_verify_search_fields
 * This file may be included multiple times. To avoid duplicate bindings:
 * - Keep a single global function reference on window.planyo_verify_search_fields
 * - Use a namespaced jQuery event when jQuery is present and remove prior namespaced handlers
 * - For native DOM, attach a single capture-phase wrapper and store a reference on the form element
 */
export default function planyoFormValidation() {
    // Define the function on window only if not already present so multiple includes reuse the same function
    if (!window.planyo_verify_search_fields || typeof window.planyo_verify_search_fields !== 'function') {
        window.planyo_verify_search_fields = function planyo_verify_search_fields(e) {
            var verify_fields = window.verify_search_fields ? window.verify_search_fields : (window.planyo_get_param ? planyo_get_param('verify_search_fields') : null);
            if (!verify_fields)
                return true;
            var verify_fields_arr = verify_fields.split(',');
            var missing_fields = [];

            for(var i = 0; i < verify_fields_arr.length; i++) {
                var label = null;
                var val = verify_fields_arr[i];
                var parts = verify_fields_arr[i].split(':');
                if (parts.length > 1) {
                    label = parts[1];
                    val = parts[0];
                }
                else {
                    label = verify_fields_arr[i].replace('prop_res_', '').replace(/_/g, ' ').replace("gps", "GPS");
                    if(label.indexOf('date') != -1)
                        label = 'Date';
                }
                if(document.getElementById('box_'+val)) {
                    if(!document.getElementById('box_'+val).value || document.getElementById('box_'+val).value == 'none') {
                        missing_fields.push(label);
                    }
                }
                else if(document.getElementById(val)) {
                    if(!document.getElementById(val).value || document.getElementById(val).value == 'none') {
                        missing_fields.push(label);
                    }
                }
            }

            if (missing_fields.length > 0) {
                var message = "Select your " + missing_fields.join(' and ') + " to start your search.";
                alert(message);
                if (e && e.preventDefault)
                    e.preventDefault();
                if(window.planyo_li_window_close)
                    planyo_li_window_close();
                return false;
            }

            return true;
        };
    }

    var handler = window.planyo_verify_search_fields;

    // Helper to bind with jQuery safely (remove previous namespaced handler and try to remove handlers named planyo_verify_search_fields)
    if (window.jQuery) {
        try {
            var $box = jQuery('#box_search_form');
            var $search = jQuery('#search_form');

            // Remove previously added namespaced handlers we control
            $box.off('submit.planyo_verify');
            $search.off('submit.planyo_verify');

            // Try to remove any handlers that were registered with the same function name (best-effort)
            try {
                var removeNamedHandlers = function($form) {
                    if (!$form || $form.length === 0) return;
                    var evts = jQuery._data && jQuery._data($form[0], 'events');
                    if (evts && evts.submit) {
                        // Copy array since we'll modify handlers
                        evts.submit.slice().forEach(function(evt) {
                            var fn = evt && (evt.handler || evt);
                            try {
                                if (fn && fn.name === 'planyo_verify_search_fields') {
                                    $form.off('submit', fn);
                                }
                            } catch (ignore) {}
                        });
                    }
                };
                removeNamedHandlers($box);
                removeNamedHandlers($search);
            } catch (ignore) {}

            if ($box.length > 0) {
                $box.on('submit.planyo_verify', handler);
            } else if ($search.length > 0) {
                $search.on('submit.planyo_verify', handler);
            }
            // We're done when jQuery binding applied
            return;
        } catch (err) {
            // fallthrough to native DOM binding if jQuery binding failed
            console.error('planyo_verify_search_fields jQuery binding error', err);
        }
    }

    // Native DOM binding: attach a single capture-phase wrapper and keep a reference on the form element
    var formEl = document.getElementById('box_search_form') || document.getElementById('search_form');
    if (formEl) {
        try { formEl.onsubmit = null; } catch (ignore) {}

        // Remove previous wrapper if present
        if (formEl.__planyo_verify_wrapper) {
            try { formEl.removeEventListener('submit', formEl.__planyo_verify_wrapper, true); } catch (ignore) {}
            try { formEl.removeEventListener('submit', formEl.__planyo_verify_wrapper, false); } catch (ignore) {}
        }

        var wrapper = function(e) {
            var res = true;
            try { res = handler(e); } catch(err) { console.error('planyo_verify_search_fields handler error', err); res = true; }
            // If the handler prevented default or returned false, stop other listeners from running
            if (res === false || (e && e.defaultPrevented)) {
                if (e && e.stopImmediatePropagation) {
                    try { e.stopImmediatePropagation(); } catch (ignore) {}
                }
            }
            return res;
        };

        formEl.__planyo_verify_wrapper = wrapper;
        // Use capture so this runs before most bubble-phase listeners and can stopImmediatePropagation
        formEl.addEventListener('submit', wrapper, true);
    }
}